import React, { FC } from 'react'

export type Props = {
  text: string | null
  clickButton: () => void
}

export const Button: FC<Props> = ({ text, clickButton }) => {
  function clickOnButton() {
    clickButton()
  }

  return (
    <div className="Visualizer-btnContainer">
      <button
        className="o-button o-button--blue Visualizer-btn"
        onClick={clickOnButton}
      >
        {text}
      </button>
    </div>
  )
}
